<template>
  <div>
    <div class="full-page-layout left-shadow">
      <div
        class="container image-container"
      >
        <div class="row hero-body">
          <div class="col col-6">
            <div class="heading">
              <h1 class="h2">
                {{ $c.text('pages.business.title') }}
              </h1>
              <p class="subtitle">
                {{ $c.text('pages.business.subtitle') }}
              </p>
              <div class="hero-buttons">
                <template v-if="$config.platform === 'ds'">
                  <nuxt-link to="/request-demo/" class="btn-primary request-demo" data-event="request_demo.click">
                    Request a Demo
                  </nuxt-link>
                </template>
                <nuxt-link
                  v-else to="/request-demo/" class="btn-primary hero-button btn-lg"
                  data-event="start_free_trial_2.click"
                >
                  {{ $c.text('pages.business.howWorks.button') }}
                </nuxt-link>
              </div>
            </div>
          </div>
        </div>
        <div class="row hero-footer">
          <div class="col col-2 sm-2">
            <span class="h6">
              Trusted by employees from:
            </span>
          </div>
          <div class="col col-2 sm-2">
            <LogoOracle class="logo-oracle" />
          </div>
          <div class="col col-2 sm-2">
            <LogoAmazon class="logo-amazon" />
          </div>
          <div class="col col-2 sm-2">
            <LogoWalmart class="logo-walmart" />
          </div>
          <div class="col col-2 sm-2">
            <LogoVisa class="logo-visa" />
          </div>
          <div class="col col-2 sm-2 hide-for-phone">
            <LogoAzercell class="logo-azercell" />
          </div>
        </div>
      </div>
      <div class="wall">
        <img :src="image">
      </div>
      <div class="wall mobile-wall">
        <img :src="mobileImage">
      </div>
    </div>
    <section class="what-we-offer tracking-section section-1" data-event="whatmakes365.scroll">
      <div class="container">
        <h2 class="section-title" :class="$config.platform === 'fa' ? 'col-8' : 'col-10'">
          {{ $c.text('pages.business.whatWeOffer') }}
        </h2>
        <div class="row">
          <div class="col-4 col">
            <div class="offer-card">
              <IconAccess class="icon" />
              <h3 class="h4">
                {{ $c.text('pages.business.whatWeOffer.card1.title') }}
              </h3>
              <p>{{ $c.text('pages.business.whatWeOffer.card1.description') }}</p>
            </div>
          </div>
          <div class="col-4 col">
            <div class="offer-card">
              <IconContent class="icon" />
              <h3 class="h4">
                {{ $c.text('pages.business.whatWeOffer.card2.title') }}
              </h3>
              <p>{{ $c.text('pages.business.whatWeOffer.card2.description') }}</p>
            </div>
          </div>
          <div class="col-4 col">
            <div class="offer-card">
              <IconCertificates class="icon" />
              <h3 class="h4">
                {{ $c.text('pages.business.whatWeOffer.card3.title') }}
              </h3>
              <p>{{ $c.text('pages.business.whatWeOffer.card3.description') }}</p>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-4 col">
            <div class="offer-card">
              <IconLiveTrainings class="icon" />
              <h3 class="h4">
                {{ $c.text('pages.business.whatWeOffer.card4.title') }}
              </h3>
              <p>{{ $c.text('pages.business.whatWeOffer.card4.description') }}</p>
            </div>
          </div>
          <div class="col-4 col">
            <div class="offer-card">
              <IconLearning class="icon" />
              <h3 class="h4">
                {{ $c.text('pages.business.whatWeOffer.card5.title') }}
              </h3>
              <p>{{ $c.text('pages.business.whatWeOffer.card5.description') }}</p>
            </div>
          </div>
          <div class="col-4 col">
            <div class="offer-card">
              <IconRecruit class="icon" />
              <h3 class="h4">
                {{ $c.text('pages.business.whatWeOffer.card6.title') }}
              </h3>
              <p>{{ $c.text('pages.business.whatWeOffer.card6.description') }}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
    <Lazy :when-visible="{ rootMargin: '200px' }">
      <section class="instructors tracking-section section-2" data-event="reskill_your_team.scroll" :class="{ 'section-2-ds': $config.platform === 'ds' }">
        <div class="container">
          <h2 v-if="$config.platform === 'ds'" class=" ds-section-title col-10">
            Upskill Your Team with World-Class Data Science Corporate Training by Renowned Experts
          </h2>
          <Slider v-if="instructors.length" class="landing" columns="col-8">
            <h3 v-if="$config.platform === 'fa'" slot="heading">
              Upskill Your Team with World-Class Training Delivered by Expert Instructors
            </h3>
            <div
              v-for="(instructor, i) in instructors"
              :key="i"
              slot="slide"
              class="col col-3 sm-6"
              mobile-no-swipe
            >
              <nuxt-link
                :key="i"
                :to="$config.platform === 'ds' ? `/instructors/${instructor.userSlug}/` : ''"
                class="single-member"
                data-event="instructors.click"
              >
                <div class="front-cover" :style="{ backgroundImage: `url(${$config.imagesUrl}/team/thumb@360_${instructor.image})` }">
                  <div class="member-desc">
                    <h3 class="h4">
                      {{ instructor.name }}
                    </h3>
                    <div class="desc">
                      {{ instructor.memberSignature }}
                    </div>
                    <Component
                      :is="icon(instructor.memberSignatureCompany)"
                      v-if="instructor.memberSignatureCompany"
                    />
                  </div>
                </div>
              </nuxt-link>
            </div>
          </Slider>
        </div>
      </section>
    </Lazy>
    <Lazy never>
      <div class="site-section dark tracking-section section-3" data-event="how365forbusinessworks.scroll">
        <div class="container">
          <div class="row">
            <div class="offset-2 col-8 sm-8 sm-offset-2 col text-center">
              <h2>{{ $c.text('pages.business.howWorks.title') }}</h2>
            </div>
          </div>
          <div
            v-for="(block,i) in businessBlocks"
            :key="i"
            class="site-section management-tools"
          >
            <div class="col-12">
              <div
                class="row"
                :class="{ 'revert': i % 2 === 1 }"
              >
                <div class="col-5 col sm-8 box" :class="{ 'offset-1': i % 2 === 1 }">
                  <div>
                    <h3>
                      {{ block.title }}
                    </h3>
                    <div v-if="$store.state.layout === 'mobile'" class="col-6 col">
                      <img loading="lazy" class="head-image" :src="getImg(i)">
                    </div>
                    <div class="body-2">
                      <p>{{ block.desc }}</p>
                    </div>
                  </div>
                </div>
                <div v-if="$store.state.layout !== 'mobile'" class="col-6 col box" :class="{ 'offset-1': i % 2 === 0 }">
                  <img loading="lazy" class="head-image" :src="getImg(i)">
                </div>
              </div>
            </div>
          </div>
          <nuxt-link
            v-if="$config.platform === 'fa'"
            to="/request-demo/"
            class="btn-primary btn-lg"
            data-event="start_free_trial_2.click"
          >
            {{ $c.text('pages.business.howWorks.button') }}
          </nuxt-link>
          <a v-else href="mailto:team@365datascience.com" class="btn-primary btn-lg">Contact our Team</a>
        </div>
      </div>
    </Lazy>
    <Lazy :when-visible="{ rootMargin: '200px' }">
      <SliderTracks
        title="Cultivate Specialized Skills with Career Tracks"
        class="tracks site-section tracking-section"
        :class="{ 'tracks-ds': $config.platform === 'ds' }"
        data-event="cultivateskills.scroll"
        mobile-no-swipe
        :columns="$config.platform === 'ds' ? 'col-12' : 'col-5'"
      />
    </Lazy>
    <section v-if="$config.platform === 'ds'" class="site-section live-trainings">
      <div class="container">
        <h2 class="col-10">
          Attend Live Training with Top Executives from Leading Companies
        </h2>
        <p class="body-2 col-10">
          Sign up for live data science corporate training events that give you direct access to experts with long-standing experience at reputable companies worldwide. Equip your workforce with critical skills and practical approaches applicable across all industries, organization standards, and business development stages.
        </p>
        <nuxt-link to="/live-trainings/" class="btn-outline-primary btn-lg">
          Explore Live Training
        </nuxt-link>
      </div>
      <div class="wall">
        <img loading="lazy" class="desktop" src="../../assets/images/business-live-trainings.png">
        <img loading="lazy" class="mobile" src="../../assets/images/business-live-trainings-mobile.png">
      </div>
    </section>
    <Lazy :when-visible="{ rootMargin: '200px' }">
      <FrequentlyAskedQuestions
        group="business" class="site-section faq tracking-section" :results="faq"
        data-event="faq.scroll"
      />
    </Lazy>
  </div>
</template>
<script>
import Lazy from 'vue-lazy-hydration';
import global from '@itbpbg/lms-components/src/mixins/global';
import ButtonArrow from '@itbpbg/lms-components/src/components/ButtonArrow';
import Slider from '@itbpbg/lms-components/src/components/Slider';
import FrequentlyAskedQuestions from '@itbpbg/lms-components/src/FrequentlyAskedQuestions';
import SliderTracks from '../../components/SliderTracks';
import PlanCard from '../../components/Business/BusinessPlanCard';
import LogoOracle from '../../assets/svg/logos/oracle.svg?vue-component';
import LogoAmazon from '../../assets/svg/logos/amazon.svg?vue-component';
import LogoWalmart from '../../assets/svg/logos/walmart.svg?vue-component';
import LogoVisa from '../../assets/svg/logos/visa.svg?vue-component';
import LogoAzercell from '../../assets/svg/logos/azercell.svg?vue-component';
import IconCheck from '../../assets/svg/check.svg?vue-component';
import IconAccess from '../../assets/svg/business/offer-icon-access.svg?vue-component';
import IconContent from '../../assets/svg/business/offer-icon-content.svg?vue-component';
import IconCertificates from '../../assets/svg/business/offer-icon-certificates.svg?vue-component';
import IconLiveTrainings from '../../assets/svg/business/offer-icon-live-trainings.svg?vue-component';
import IconLearning from '../../assets/svg/business/offer-icon-learning.svg?vue-component';
import IconRecruit from '../../assets/svg/business/offer-icon-recruit.svg?vue-component';

export default {
  components: {
    ButtonArrow,
    Slider,
    PlanCard,
    FrequentlyAskedQuestions,
    SliderTracks,
    LogoOracle,
    LogoAmazon,
    LogoWalmart,
    LogoVisa,
    LogoAzercell,
    Lazy,
    IconCheck,
    IconAccess,
    IconContent,
    IconCertificates,
    IconLiveTrainings,
    IconLearning,
    IconRecruit,
  },
  mixins: [global],
  async asyncData({ $axios, route, $config }) {
    const { page, instructors, faq } = await $axios.$get('/pages/data/business');
    page.fullPath = `${$config.siteUrl}${route.fullPath}`;
    page.metaFullImageUrl = `${$config.siteUrl}/resources/${page.metaImage}`;

    page.created = page.created || new Date();
    page.updated = page.updated || new Date();
    return { instructors, page, faq };
  },
  data() {
    return {
      planPrivileges: [
        'Admin dashboard', 'Subscription management', 'Task management', 'Advanced reporting',
        'Data export', '150 hours of video', '650+ exercises', 'Exams',
        'Certificates', 'Dedicated support', 'Priority onboarding', 'Recruit talents',
      ],
      businessBlocks: [
        {
          title: this.$c.text('pages.business.howWorks.block1.title'),
          desc: this.$c.text('pages.business.howWorks.block1.desc'),
        },
        {
          title: this.$c.text('pages.business.howWorks.block2.title'),
          desc: this.$c.text('pages.business.howWorks.block2.desc'),
        },
        {
          title: this.$c.text('pages.business.howWorks.block3.title'),
          desc: this.$c.text('pages.business.howWorks.block3.desc'),
        },
        {
          title: this.$c.text('pages.business.howWorks.block4.title'),
          desc: this.$c.text('pages.business.howWorks.block4.desc'),
        },
        {
          title: this.$c.text('pages.business.howWorks.block5.title'),
          desc: this.$c.text('pages.business.howWorks.block5.desc'),
        },
        {
          title: this.$c.text('pages.business.howWorks.block6.title'),
          desc: this.$c.text('pages.business.howWorks.block6.desc'),
        },
      ],
    };
  },
  head() {
    const linkedData = this.$linkedDataLoad([
      { key: 'WebSite' },
      { key: 'WebPage', values: this.page },
    ]);

    return {
      titleTemplate: `${this.page.metaTitle}%s`,
      link: [
        { rel: 'canonical', href: this.canonicalURL() },
      ],
      meta: this.metaProps(this.page),
      script: [linkedData],
    };
  },
  computed: {
    image() {
      if (this.$config.platform === 'fa') {
        return require('../../assets/images/fa/fa-b2b-preview-image.jpg');
      }
      return require('../../assets/images/b2b-preview-image.jpg');
    },
    mobileImage() {
      if (this.$config.platform === 'fa') {
        return require('../../assets/images/fa/fa-b2b-preview-image-mobile.jpg');
      }
      return require('../../assets/images/b2b-preview-image-mobile.jpg');
    },
  },
  methods: {
    getImg(imageIdx) {
      if (this.$config.platform === 'fa') {
        return require(`../../assets/images/fa/fa-b2b-img${imageIdx + 1}.png`);
      }
      return require(`../../assets/images/b2b-img${imageIdx + 1}.jpg`);
    },
    icon(img) {
      return img ? require(`../../assets/svg/companies/logo-${img.slug}.svg?vue-component`) : '';
    },
  },
};
</script>

<style lang="scss" scoped>
.full-page-layout {
  background-color: var(--main-dark);
  position: relative;

  &.left-shadow {
    .wall:before {
      content: '';
      top: 0;
      left: -130px;
      background-color: var(--main-dark);
      position: absolute;
      height: 100%;
      width: 200px;
      z-index: 2;
    }
  }

  .wall {
    position: absolute;
    right: 0;
    top: 0;
    height: 780px;
    min-height: 100vh;
    width: auto;
    z-index: 0;

    img {
      height: 780px;
      min-height: 100vh;
    }
  }

  .mobile-wall {
    display: none;
  }

  &:before,
  &:after {
    content: '';
    left: 0;
    position: absolute;
    width: 100%;
    z-index: 2;
  }

  &:before {
    background: linear-gradient(180deg, var(--main-dark) 0%, rgba(0, 12, 31, 0) 100%);
    height: 110px;
    top: 0;
  }

  .container {
    position: relative;
    align-items: center;
    min-height: 380px;

    &.image-container {
      height: 780px;
      min-height: 100vh;

      > .row {
        margin: 0 -12px;
      }
    }

    .hero-body {
      align-items: center;
      height: calc(100% - 93px);

      .heading.hero-ds {
        padding-right: var(--spacing-40);
      }

      > div {
        height: inherit;
        display: flex;
        align-items: center;
        position: relative;
        color: var(--main-light);
        z-index: 5;
        min-height: 380px;

        .h2 {
          font-size: 44px;
          margin: 0 auto var(--spacing-16);
        }

        .subtitle {
          color: var(--main-light-shade-4);
          margin: 0 0 var(--spacing-36);
        }

        .body-2 {
          color: var(--main-light-shade-4);
          margin: 0;
        }

        .hero-buttons {
          display: flex;

          .btn-light-shade,
          .btn-primary {
            flex-grow: 1;
            padding: var(--spacing-14) var(--spacing-16);
          }
        }

        a {
          max-width: 230px;
          min-height: var(--spacing-48);
          margin-right: var(--spacing-12);
          font-weight: 600;
          line-height: 100%;
        }
      }
    }

    .hero-footer {
      height: 93px;
      position: relative;

      &:before {
        content: '';
        position: absolute;
        width: calc(100% - 30px);
        height: 1px;
        background: rgba(255, 255, 255, 0.12);
        top: 0;
        left: 50%;
        transform: translate(-50%);
        z-index: 5;
      }

      .col-2 {
        align-items: center;
        justify-content: center;
        display: flex;
        z-index: 5;
        width: 16%;
        max-width: 16%;
        flex: 0 0 16%;

        .logo-oracle {
          width: 120px;
        }

        .logo-amazon {
          width: 120px;
        }

        .logo-walmart {
          width: 130px;
        }

        .logo-visa {
          width: 120px;
        }

        .logo-azercell {
          width: 120px;
        }

        &:first-of-type {
          width: 20%;
          max-width: 20%;
          flex: 0 0 20%;
        }

        @include bp($bp-phone) {
          width: 100%;
          max-width: 100%;
          flex: 0 0 100%;

          &:first-of-type {
            width: 100%;
            max-width: 100%;
            flex: 0 0 100%;
          }
        }

        .h6 {
          color: var(--main-light-shade-3);
          margin: 0;
        }
      }
    }
  }
}

section {
  padding: 120px 0;

  h2 {
    text-align: center;
    margin: 0 auto;
  }

  ::v-deep .slider-header {
    justify-content: center;
  }
}

.section-2 {
  padding: var(--spacing-160) 0;

  &.section-2-ds {
    padding: var(--spacing-120) 0;

    .ds-section-title {
      padding: 0 var(--spacing-16);
    }
  }
}

.section-3 {
  h2 {
    margin-bottom: 0;
  }
}

.what-we-offer {
  background-color: var(--main-light-shade-1);

  .section-title {
    margin-bottom: var(--spacing-48);
    padding: 0 var(--spacing-24);
  }

  .offer-card {
    background-color: var(--main-light);
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
    border-radius: 7px;
    text-align: center;
    padding: 42px 32px;
    min-height: 464px;
    height: 100%;
    position: relative;
    display: inline-block;

    .h4 {
      margin-top: 100px;
      margin-bottom: 8px;
    }

    .icon {
      position: absolute;
      left: 50%;
      transform: translate(-50%);
      top: 42px;
    }

    p {
      color: var(--main-dark-shade-3);
    }
  }

  .container .row {
    margin-bottom: var(--spacing-48);
  }
}

.site-section {
  display: flex;
  padding-top: var(--spacing-120);
  padding-bottom: var(--spacing-120);

  &.tracks {
    padding-bottom: var(--spacing-100);
  }

  &.tracks-ds {
    padding-bottom: var(--spacing-120);

    ::v-deep {
      .slider-container .slider-header {
        text-align: center;
      }
    }
  }

  &.dark {
    padding-bottom: var(--spacing-120);

    a {
      display: block;
      margin: 0 auto;
      width: 280px;
      padding: var(--spacing-24) 0;
      font-weight: 600;
      font-size: 21px;
    }
  }

  &.management-tools {
    padding: var(--spacing-80) 0 var(--spacing-60);

    .revert {
      .box {
        &:first-of-type {
          order: 2;

          > div {
            float: right;
          }
        }

        &:last-of-type {
          order: 1;
          padding-right: 0;
        }
      }
    }

    img {
      max-width: 100%;
      width: 100%;
      border-radius: 13px;
    }

    h3 {
      margin-bottom: var(--spacing-16);
    }

    .body-2 p {
      color: var(--main-light-shade-4);
      margin-bottom: var(--spacing-40);
    }

    .col-5 {
      display: flex;
      align-items: center;
    }
  }

  &.slider-tracks {
    ::v-deep .slider-header h2 {
      max-width: 100%;
    }
  }

  &.live-trainings {
    background-color: var(--main-dark);
    color: var(--main-light);
    text-align: center;
    position: relative;
    padding-bottom: 400px;

    p {
      color: var(--main-light-shade-4);
      margin: 36px auto;
      padding: 0 var(--spacing-16);
    }

    a {
      margin: 36px 0;
      max-width: 350px;
      width: 100%;
    }

    .wall {
      position: absolute;
      bottom: 32px;
      left: 50%;
      transform: translateX(-50%);
      height: auto;
      overflow: hidden;
      max-width: 100%;

      img {
        &.mobile { display: none; }
      }
    }

    .btn-lg {
      border-width: 2px;
      font-weight: 600;
      margin-top: 0;
      border-color: var(--accent);
      color: var(--accent);
    }
  }

  @include bp($bp-phone) {
    &.management-tools {
      padding: var(--spacing-80) 0 0;
    }

    .text-center {
      text-align: left;
    }

    .sm-offset-2 {
      margin-left: 0;
    }
  }

  @include bp($bp-mobile) {
    padding-top: 80px;
    padding-bottom: 80px;

    .text-center {
      text-align: left;
    }

    &.management-tools {
      .box:first-of-type {
        order: 2;

        .col {
          padding: 0;
          order: -1;
          display: flex;
          flex-direction: column;

          h3 {
            margin: var(--spacing-36) 0 0 0;
          }
        }
      }
    }
  }
}

.single-member {
  .front-cover {
    background-color: #C4C4C4;
    border-radius: 7px;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    image-rendering: -webkit-optimize-contrast;
    position: relative;
    padding-top: 130%;
    overflow: hidden;

    .member-desc {
      bottom: 0;
      position: absolute;
      padding: var(--spacing-24) var(--spacing-36);
      text-align: center;
      width: 100%;

      .h4 {
        color: var(--main-light);
        margin-bottom: var(--spacing-8);
      }

      .desc {
        color: rgba(255, 255, 255, 0.74);
        line-height: 110%;
        font-size: 18px;
        margin-bottom: var(--spacing-8);
      }
    }
  }
}

@include bp($bp-mobile) {
  .full-page-layout {
    &:before {
      height: 370px;
      top: -179px;
      background: linear-gradient(180deg, #000C1F 0%, rgba(0, 12, 31, 0.96) 70.77%, rgba(0, 12, 31, 0) 100%);
    }

    .container {
      .hero-body h1 {
        font-size: 32px;
      }

      &.image-container {
        padding-bottom: var(--spacing-30);
      }

      .hero-body {
        > div {
          .h2 {
            font-size: 40px;
          }
        }
      }

      .hero-footer {
        height: auto;

        .col-2 {
          height: 80px;
        }
      }
    }

    .heading {
      width: 100%;

      .subtitle {
        padding: 0;
        margin: 0 !important;
      }
    }

    &:after {
      display: none;
    }

    .wall {
      height: 499px;
      min-height: auto;
      width: 100%;
      overflow: hidden;
      padding-top: 74px;

      &:after {
        background: linear-gradient(0deg, var(--main-dark) 0%, rgba(0, 12, 31, 0) 100%);
        bottom: auto;
        top: 320px;
        left: 0;
        height: 130px;
        width: 100%;
      }

      img {
        height: auto;
        min-height: auto;
        width: 100%;
        object-fit: cover;
        object-position: top;
      }
    }

    .container,
    .container.image-container {
      padding-top: 436px;
      height: auto;
      min-height: 100vh;
      padding-bottom: var(--spacing-30);

      .row {
        .heading {
          height: 20%;
        }

        > div {
          .btn-primary,
          .btn-light-shade,
          .btn-primary-transparent {
            max-width: 100%;
            width: 100%;
            margin-right: 0;
          }

          .btn-primary {
            margin-top: var(--spacing-48);
          }

          .btn-primary-transparent {
            margin-bottom: var(--spacing-48);
          }

          .hero-buttons {
            width: 100%;
            max-width: 350px;
            display: flex;
            flex-direction: column;
            margin: var(--spacing-48) auto var(--spacing-60);

            .btn-primary,
            .btn-light-shade {
              width: 100%;
              height: var(--spacing-56);
              padding: var(--spacing-18);
            }

            .btn-primary {
              margin-top: 0;
              order: 1;
            }

            .btn-light-shade {
              order: 2;
            }

            @include bp($bp-phone) {
              max-width: 100%;
            }
          }
        }
      }
    }

    .container:after {
      content: '';
      position: absolute;
      top: auto;
      left: 0;
      bottom: 100%;
      width: 100%;
      height: 150px;
      min-height: auto;
      z-index: 1;
      background: linear-gradient(0deg, var(--main-dark) 0%, rgba(0, 12, 31, 0) 100%);
    }

    &.left-shadow .wall:before {
      background: linear-gradient(0deg, #000C1F 0%, rgba(0, 12, 31, 0.96) 70.77%, rgba(0, 12, 31, 0) 100%);
      width: 100%;
      top: calc(100% - 179px);
      left: 0;
      right: 0;
    }
  }

  section {
    padding: 80px 0;
  }

  section,
  .site-section {
    ::v-deep h2 {
      font-size: 32px;
    }

    &.dark {
      padding-bottom: var(--spacing-80);

      a {
        margin-top: var(--spacing-20);
        padding: var(--spacing-20) 0;
        font-size: var(--spacing-18);
        line-height: 100%;
      }
    }
  }

  .what-we-offer {
    h2 {
      font-size: 28px !important;
    }

    .offer-card {
      min-height: auto;

      .h4 {
        font-size: 24px;
      }
    }

    .row:nth-child(2) {
      .col {
        margin-bottom: var(--spacing-28);
      }
    }

    .row:nth-child(3) {
      .col {
        margin-bottom: var(--spacing-28);

        &:last-of-type {
          margin-bottom: 0;
        }
      }
    }

    .container .row {
      margin: 0 -12px var(--spacing-28);

      > div:not(:last-of-type) {
        margin-bottom: var(--spacing-28);
      }
    }
  }

  .instructors {
    padding: var(--spacing-80) 0;

    .slider-header .heading h3 {
      font-size: 32px;
    }

    ::v-deep .slider-header {
      margin-bottom: 32px;
      margin-top: 16px;

      .heading,
      .subtitle {
        display: none;
      }
    }
  }

  .site-section {
    &.management-tools {
      .row {
        margin: 0;
        justify-content: center;

        .box {
          > div {
            display: grid;

            h3 {
              margin-top: var(--spacing-36);
            }

            .body-2 {
              p {
                margin-bottom: var(--spacing-20);
              }
            }
          }
        }

        .col {
          padding: 0;
        }
      }
    }

    &.live-trainings {
      padding-bottom: 424px;

      p {
        padding: 0;
        margin: var(--spacing-16) 0 var(--spacing-24);
      }

      .wall {
        height: 400px;

        .mobile { display: block !important; }
        .desktop { display: none; }
      }
    }

    &.tracks-ds {
      ::v-deep {
        .slider-container .slider-header {
          text-align: left;
        }
      }
    }
  }

  .slider-tracks {
    ::v-deep .slider-container {
      .row {
        flex-wrap: wrap;

        .col:not(:last-child) {
          margin-bottom: 36px;
        }
      }

      .dots {
        display: none;
      }
    }
  }
}

@include bp($bp-phone) {
  .full-page-layout {
    .wall {
      display: none;

      &.mobile-wall {
        display: block;
      }
    }

    .container {
      .hero-body {
        .subtitle {
          line-height: 24px;
        }
      }
    }
  }

  .site-section {
    &.live-trainings a,
    &.dark a {
      max-width: 100%;
      width: 100%;
    }
  }

  .what-we-offer .section-title {
    padding: 0;
    margin-bottom: var(--spacing-28);
  }
}

.fa {
  .full-page-layout {
    .container {
      .hero-body > div .hero-buttons .hero-button {
        max-width: 260px;
        min-height: 58px;
        padding: 18px;
      }
    }
  }

  section {
    ::v-deep .slider-header {
      flex-direction: unset;
      margin-bottom: 0;
      justify-content: space-between;

      .heading h3 {
        text-align: left;
      }
    }

    &.what-we-offer {
      background: var(--main-light-shade-2);

      .offer-card {
        box-shadow: 0 4px 30px rgba(0, 0, 0, 0.05);
        border-radius: 10px;
      }
    }

    &.slider-tracks {
      ::v-deep .slider-header {
        margin-bottom: var(--spacing-36);

        .heading h2 {
          max-width: 470px;
        }
      }
    }
  }

  .site-section.dark {
    background: linear-gradient(135deg, rgba(3, 111, 253, 0.14) 19.77%, rgba(3, 111, 253, 0.05) 36.77%, rgba(1, 22, 51, 0) 63.97%);
    background-color: var(--main-dark);
  }

  @include bp($bp-laptop) {
    .full-page-layout .container .hero-body > div .hero-buttons .hero-button {
      max-width: 225px;
    }
  }

  @include bp($bp-mobile) {
    .full-page-layout {
      .wall:before {
        background: linear-gradient(360deg, #011633 0%, #011633 70.77%, rgba(1, 22, 51, 0) 100%);
      }
    }

    .site-section.dark {
      background: linear-gradient(179.58deg, rgba(3, 111, 253, 0.14) -0.05%, rgba(3, 111, 253, 0.05) 25.66%, rgba(1, 22, 51, 0) 99.77%), var(--main-dark);

      a {
        margin-top: var(--spacing-20);
      }
    }

    .site-section.management-tools {
      padding-bottom: 0;
    }

    .site-section.faq {
      padding-top: var(--spacing-120);

      ::v-deep {
        .h3 {
          font-size: 28px;
        }
      }
    }

    section {
      ::v-deep .slider-header {
        flex-direction: column;
        margin-bottom: var(--spacing-36);

        .heading {
          display: flex;
        }
      }
    }
  }

  @include bp($bp-phone) {
    .full-page-layout {
      .container {
        &:after {
          background: linear-gradient(0deg, var(--main-dark) 0%, rgba(0, 12, 31, 0) 100%);
        }

        .hero-body > div .hero-buttons .hero-button {
          max-width: 100%;
        }
      }
    }

    .slider-tracks.container.tracks.site-section.tracking-section {
      background: var(--main-light);
    }
  }
}
</style>
